import { revokeAdmin } from './states';

export const services = {
  revokeAdmin,
};
